import * as React from 'react';
import { AppTabs } from '../../components';
import { DishTagsTab, GalleryTab } from './components';

interface Props {}

export enum WebsiteTabList {
  GALLERY = 'gallery',
  DISH_TAGS = 'dish-tags',
}

export const Website: React.FC<Props> = () => {
  const tabs = [
    { label: 'Gallery', value: WebsiteTabList.GALLERY },
    { label: 'Dish Tags', value: WebsiteTabList.DISH_TAGS },
  ];

  return (
    <AppTabs tabs={tabs}>
      {(activeTab) => {
        switch (activeTab) {
          case WebsiteTabList.GALLERY:
            return <GalleryTab />;
          case WebsiteTabList.DISH_TAGS:
            return <DishTagsTab />;
          default:
        }
      }}
    </AppTabs>
  );
};
